import { Flex } from 'antd';
import { FunctionComponent, ReactNode } from 'react';

// components
import Icon from 'utils/icon';

// styles
import styles from '../pages/dashboard.module.scss';
import NumberElement from 'components/number/number';

interface StatisticsItemComponentProps {
	headerIcon?: boolean;
	headerTitle?: string;
	headerDesc?: string;
	bodyDesc?: string;
	bodyTitle: ReactNode;
	change?: number | null;
}

const StatisticsItemComponent: FunctionComponent<StatisticsItemComponentProps> = ({
	headerIcon,
	headerTitle,
	headerDesc,
	bodyDesc,
	bodyTitle,
	change,
}) => {
	return (
		<div className={styles.statisticsItem}>
			<Flex vertical justify="space-between" gap={20} className="h-100">
				{/* header */}
				<Flex justify="space-between" align="center">
					{headerIcon && <Icon name="stair" />}
					{headerTitle && <span className="text-light">{headerTitle}</span>}
					{headerDesc && <span className="text-light">{headerDesc}</span>}
				</Flex>

				{/* body */}
				<div>
					{bodyDesc && <p className="mb-1 text-light">{bodyDesc}</p>}

					<Flex justify="space-between" align="center">
						<h3 className="mb-0">{bodyTitle}</h3>

						{change !== undefined && change !== null && (
							<span
								className={`status small d-flex align-items-center gap-1 ${change > 0 ? 'green' : change < 0 ? 'red' : ''}`}
								style={{ padding: '3px 10px', borderRadius: 10 }}>
								{change !== 0 && <Icon name={change > 0 ? 'arrowUp' : 'arrowDown'} height={12} width={7} />}
								<NumberElement value={change} decimalScale={2} />%
							</span>
						)}
					</Flex>
				</div>
			</Flex>
		</div>
	);
};

export default StatisticsItemComponent;
